import { ChangeDetectorRef, Directive, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Status } from '@df/core/status';
import { IResponseRemoveFromBasket } from '@df/session/api/basket/basket.service';
import { Customer } from '@df/session/api/customer';
import find from 'lodash-es/find';
import { Subscription } from 'rxjs/internal/Subscription';
import { GiftboxBasketItem } from './giftbox-basket-item';
import { GiftboxService } from './giftbox.service';

@Directive()
export class GiftboxBasketItemComponentDef implements OnInit, OnDestroy {
    @Input()
    item!: GiftboxBasketItem;

    giftboxService = inject(GiftboxService);
    public readonly customer = inject(Customer);

    removeStatus = new Status();

    private basketSubscription?: Subscription;

    /**
     * returns true if item no longer exists in basket, item remains displayed for a moment to show removal message
     */
    get removed() {
        return !find(this.customer.basket.data.gifting?.items, itemData => itemData.id === this.item.data.id);
    }

    constructor(protected _ref: ChangeDetectorRef) {}

    ngOnInit() {
        // required for removal message being displayed, giftbox can be removed in its edit modal so we need to monitor basket changes
        this.basketSubscription = this.customer.basket.subscribe(() => {
            this._ref.detectChanges();
        });
    }

    ngOnDestroy() {
        this.basketSubscription?.unsubscribe();
    }

    /**
     * Removes giftbox item from basket
     * @return {promise}
     */
    remove(): Promise<IResponseRemoveFromBasket> {
        return this.item.remove(this.removeStatus);
    }
}
